import React from "react";
import { Link } from "react-router-dom";

const BASE =
  "inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg font-semibold text-sm " +
  "transition-all duration-200 cursor-pointer focus-visible:outline focus-visible:outline-2 " +
  "focus-visible:outline-offset-2 focus-visible:outline-rf-accent";

const VARIANTS = {
  primary:
    "bg-rf-accent text-rf-bg-primary hover:-translate-y-px hover:shadow-[0_0_24px_rgba(0,212,170,0.15)]",
  secondary:
    "border border-rf-border bg-transparent text-rf-text-primary hover:border-rf-text-secondary hover:bg-rf-bg-secondary",
};

/**
 * Polymorphic CTA per design-system/landing.md §4: internal routes use `to`
 * (client-side nav), external destinations (GitHub install/authorize URLs)
 * use `href` (real navigation — these are full page loads by design), and
 * `onClick` alone renders a plain button for in-page actions.
 */
export default function CTAButton({
  variant = "primary",
  to,
  href,
  onClick,
  children,
  className = "",
  ...rest
}) {
  const classes = `${BASE} ${VARIANTS[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes} {...rest}>
      {children}
    </button>
  );
}
